import { AxiosResponse } from 'axios';
import { ISpecialEventBookings } from '../Models/ISpecialEventBookings';
import { ISpecialEventCategory } from '../Models/ISpecialEventCategory';
import BaseApi from './BaseApi';

/**
 * The SpecialEventsApi class.
 *
 */
class SpecialEventsApi extends BaseApi {
	constructor() {
        super('specialevents');
	}
	
	/** 
	 * Get category
	 *  
	 * @return {Promise} The request promise.
	*/
	public getCategory = (code: string): Promise<AxiosResponse<ISpecialEventCategory>> => {		
		return this._get(code, {});
	}
	
	/** 
	 * Get category with details (events)
	 *  
	 * @return {Promise} The request promise.
	*/
	public getCategoryDetails = (code: string): Promise<AxiosResponse<ISpecialEventCategory>> => {		
		return this._get(`${code}/details`, {});
	}

	/** 
	 * Get event category bookings 
	 *  
	 * @return {Promise} The request promise.
	*/
	public getCategoryEventBookings = (code: string, from: string, to: string): Promise<AxiosResponse<ISpecialEventBookings[]>> => {		
		return this._get(`${code}/bookings`, {
			from, 
			to
		});
	}
}

export default SpecialEventsApi;